module.exports = __webpack_public_path__ + "assets/img/Infographics5.a065c577.png";